import btcIcon from "@assets/images/futures_pairs/btcusdt.svg";
import ethIcon from "@assets/images/futures_pairs/ethusdt.svg";
import bnbIcon from "@assets/images/futures_pairs/bnbusdt.svg";
import solIcon from "@assets/images/futures_pairs/solusdt.svg";
import xrpIcon from "@assets/images/futures_pairs/xrpusdt.svg";
import adaIcon from "@assets/images/futures_pairs/adausdt.svg";
import dogeIcon from "@assets/images/futures_pairs/dogeusdt.svg";
import ltcIcon from "@assets/images/futures_pairs/ltcusdt.svg";
import linkIcon from "@assets/images/futures_pairs/linkusdt.svg";
import avaxIcon from "@assets/images/futures_pairs/avaxusdt.svg";
import dotIcon from "@assets/images/futures_pairs/dotusdt.svg";
import trxIcon from "@assets/images/futures_pairs/trxusdt.svg";
import atomIcon from "@assets/images/futures_pairs/atomusdt.svg";
import nearIcon from "@assets/images/futures_pairs/nearusdt.svg";
import arbIcon from "@assets/images/futures_pairs/arbusdt.svg";
import opIcon from "@assets/images/futures_pairs/opusdt.svg";
import bchIcon from "@assets/images/futures_pairs/bchusdt.svg";
import shibIcon from "@assets/images/futures_pairs/shibusdt.svg";
import pepeIcon from "@assets/images/futures_pairs/pepeusdt.svg";
import aptIcon from "@assets/images/futures_pairs/aptusdt.svg";
import suiIcon from "@assets/images/futures_pairs/suiusdt.svg";
import etcIcon from "@assets/images/futures_pairs/etcusdt.svg";
import filIcon from "@assets/images/futures_pairs/filusdt.svg";

const pairMeta = {
  BTCUSDT: { icon: btcIcon, fullName: "Bitcoin" },
  ETHUSDT: { icon: ethIcon, fullName: "Ethereum" },
  BNBUSDT: { icon: bnbIcon, fullName: "Binance Coin" },
  SOLUSDT: { icon: solIcon, fullName: "Solana" },
  XRPUSDT: { icon: xrpIcon, fullName: "Ripple" },
  ADAUSDT: { icon: adaIcon, fullName: "Cardano" },
  DOGEUSDT: { icon: dogeIcon, fullName: "Dogecoin" },
  LTCUSDT: { icon: ltcIcon, fullName: "Litecoin" },
  LINKUSDT: { icon: linkIcon, fullName: "Chainlink" },
  AVAXUSDT: { icon: avaxIcon, fullName: "Avalanche" },
  DOTUSDT: { icon: dotIcon, fullName: "Polkadot" },
  TRXUSDT: { icon: trxIcon, fullName: "TRON" },
  ATOMUSDT: { icon: atomIcon, fullName: "Cosmos" },
  NEARUSDT: { icon: nearIcon, fullName: "NEAR Protocol" },
  ARBUSDT: { icon: arbIcon, fullName: "Arbitrum" },
  OPUSDT: { icon: opIcon, fullName: "Optimism" },
  BCHUSDT: { icon: bchIcon, fullName: "Bitcoin Cash" },
  "1000SHIBUSDT": { icon: shibIcon, fullName: "Shiba Inu" },
  "1000PEPEUSDT": { icon: pepeIcon, fullName: "Pepe" },
  APTUSDT: { icon: aptIcon, fullName: "Aptos" },
  SUIUSDT: { icon: suiIcon, fullName: "Sui" },
  ETCUSDT: { icon: etcIcon, fullName: "Ethereum Classic" },
  FILUSDT: { icon: filIcon, fullName: "Filecoin" },
};

export const getPairTicker = (slug) =>
  String(slug || "").replace(/(USDT|USDC)$/i, "");

export const getPairMeta = (slug) =>
  pairMeta[String(slug || "").toUpperCase()] || null;

export const getPairDisplay = (pair) => {
  if (!pair) {
    return { title: "...", ticker: "" };
  }

  const meta = getPairMeta(pair.slug);
  const ticker = getPairTicker(pair.slug);
  const title = meta?.fullName || pair.label || pair.name || ticker || "...";

  return {
    title,
    ticker: ticker && ticker !== title ? ticker : "",
  };
};
